import IpHelper from './ipHelper'
import {toast} from 'react-toastify'
import regexPatterns from './regexPatterns'

const textLengthChecker = (text, length) => {
    return text?.length > length ? text.substring(0, length) + '...' : text
}

const getTextFromArray = arr => {
    return arr.join(',').toUpperCase()
}

const pluralize = (count) => count === 1 || count === 0 ? '' : 's'

const getResourceState = (condition, types) => {
    if (condition) {
        return types[0]
    }
    return types[1]
}

const replaceAllChars = (text, char, replacedValue) => {
    if (!Array.isArray(replacedValue) || !Array.isArray(char)) {
        return text.replace(new RegExp(char, 'g'), replacedValue)
    }

    const regex = new RegExp(char.join('|'), 'g')
    return text.replace(regex, match => {
        const index = char.indexOf(match)
        return replacedValue[index] || ''
    })
}

const capitalizeFirstChar = string => {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

const getHostnameFromUrl = url => {
    let urlObj = {}

    try {
        urlObj = new URL(url)
    } catch (e) {
        return ''
    }

    return urlObj.hostname
}

const generateNameFromUrl = url => {
    const hostname = getHostnameFromUrl(url)
    if (hostname === '') {
        return ''
    }

    const splitUrl = hostname.split('.')
    if (splitUrl?.length < 2) {
        return ''
    }

    const name = splitUrl[0] === 'www' ? splitUrl[1] : regexPatterns.ipv4.test(hostname) ? '' : splitUrl[0]

    return capitalizeFirstChar(replaceAllChars(name, '-', ' '))
}

const normalizeUrl = url => {
    const hasProtocol = url.includes('://')
    const isIpOrIpv4Prefix = IpHelper.isIp(url) || IpHelper.isPrefixOfIpv4(url)

    if (hasProtocol) {
        return url
    }

    if (isIpOrIpv4Prefix) {
        return `http://${url}`
    }

    return `https://${url}`
}

const getNormalizedUrl = url => {
    const checkedUrl = normalizeUrl(url)
    if (checkedUrl.includes('.')) {
        return checkedUrl
    }
    return url
}

const addPrefix = (url, type) => {
    const seperator = '://'
    const prefix = `${type || 'icmp'}://`
    const defaultPrefix = 'https://'
    if (!url.includes(seperator)) {
        url = `${defaultPrefix}${url}`
    }
    url = new URL(url)
    if (url.port) {
        url.port = ''
    }
    return `${prefix}${url.host}`
}

const copyText = text => {
    navigator.clipboard.writeText(text).then(() => {
        toast.success('Copied to clipboard')
    })
}

const addEmptyLine = (data = []) => {
    return data.join('\n')
}

const createSectionTitle = (text) => {
    const key = ':intermediarySymbol'
    if (text.includes(key)) {
        const textArray = text.split(key)
        return <>
            {textArray[0]}
            <span className='section-title-intermediary-symbol'>&</span>
            {textArray[1]}
        </>
    }
    return text
}

export const trimStringValues = (values) => {
    return Object.fromEntries(
        Object.entries(values).map(([key, value]) => {
            if (Array.isArray(value)) {
                return [key, value.map(item => typeof item === 'string' ? item.trim() : item)]
            }
            return [key, typeof value === 'string' ? value.trim() : value]
        }))
}

export default {
    textLengthChecker,
    getTextFromArray,
    getResourceState,
    replaceAllChars,
    capitalizeFirstChar,
    generateNameFromUrl,
    normalizeUrl,
    getNormalizedUrl,
    addPrefix,
    copyText,
    addEmptyLine,
    createSectionTitle,
    pluralize
}
